// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whatsNewItemWrapper__dnDbt {
  width: 100%;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
}
.whatsNewItemWrapper__dnDbt:not(:last-child) {
  margin-bottom: 15px;
}

.whatsNewItemBody__1Ok8M {
  padding: 25px;
}

.whatsNewItemTitle__ldwny {
  margin: unset;
  color: var(--tables-primary-row-text-main);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
}
.whatsNewItemTitle__ldwny * {
  margin: unset;
}

.notViewed__HVAiT {
  padding-left: 18px;
  position: relative;
}
.notViewed__HVAiT::before {
  content: "";
  width: 8px;
  height: 8px;
  background-color: var(--buttons-surface);
  border-radius: 50%;
  position: absolute;
  top: 5px;
  left: 0;
}

.whatsNewItemDescription__NdPH1 {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 0;
  color: var(--tables-secondary-row-sub-title-text);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
}
.whatsNewItemDescription__NdPH1 img {
  max-width: 600px;
}
.whatsNewItemDescription__NdPH1 ol::marker,
.whatsNewItemDescription__NdPH1 li::marker {
  color: var(--tables-secondary-row-sub-title-text);
}
.whatsNewItemDescription__NdPH1 li {
  margin: unset;
}
.whatsNewItemDescription__NdPH1 * {
  margin-top: 15px;
  margin-bottom: 0;
  color: var(--tables-secondary-row-sub-title-text);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
}
.whatsNewItemDescription__NdPH1 .skeletonText__BrDTb {
  height: 100px;
}

.whatsNewItemFooter__jKtgZ {
  padding: 15px 25px;
  display: flex;
  align-items: center;
  border-top: 1px solid var(--tables-primary-row-stroke);
  justify-content: space-between;
}
.whatsNewItemFooter__jKtgZ .skeletonText__BrDTb {
  height: 40px;
}

.whatsNewItemDate__jvWzB {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.whatsNewItemDateIcon__AOOVB path {
  stroke: var(--tables-secondary-row-sub-title-text);
}

.whatsNewItemMarkFavorite__c2_MG {
  margin-left: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.whatsNewItemMarkFavoriteIcon__Mi571 {
  cursor: pointer;
}
.whatsNewItemMarkFavoriteIcon__Mi571 path {
  stroke: var(--buttons-surface);
}
.whatsNewItemMarkFavoriteIcon__Mi571 path:hover {
  stroke: var(--buttons-hover);
}

.skeletonWrapper__AplYc .whatsNewItemTitle__ldwny {
  height: 16px;
}
.skeletonWrapper__AplYc .whatsNewItemDescription__NdPH1 {
  margin-top: 25px;
  height: 40px;
}

.skeletonTextTitle__HtKjQ {
  height: 16px;
  max-width: 400px;
}

.skeletonTextDescription__iRHeJ {
  height: 40px;
  margin-top: 0;
}

.skeletonTextFooter__PkE5I {
  height: 18px;
  max-width: 145px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/WhatsNew/components/NewItem/style.module.scss"],"names":[],"mappings":"AAkFA;EACE,WAAA;EACA,qDAAA;EACA,sCAAA;AAjFF;AAmFE;EACE,mBAAA;AAjFJ;;AAqFA;EACE,aAAA;AAlFF;;AAqFA;EACE,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAlFF;AAoFE;EACE,aAAA;AAlFJ;;AAsFA;EACE,kBAAA;EACA,kBAAA;AAnFF;AAqFE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AAnFJ;;AAuFA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EAtDA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7BF;AAkFE;EACE,gBAAA;AAhFJ;AAqFI;;EACE,iDAAA;AAlFN;AAsFE;EACE,aAAA;AApFJ;AAuFE;EACE,gBAAA;EACA,gBAAA;EA1EF,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAVF;AAoFE;EACE,aAAA;AAlFJ;;AAsFA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sDAAA;EACA,8BAAA;AAnFF;AAqFE;EACE,YAAA;AAnFJ;;AAuFA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AApFF;;AAwFE;EACE,kDAAA;AArFJ;;AAyFA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAtFF;;AAyFA;EACE,eAAA;AAtFF;AAwFE;EACE,8BAAA;AAtFJ;AAwFI;EACE,4BAAA;AAtFN;;AA4FE;EACE,YAAA;AAzFJ;AA4FE;EACE,gBAAA;EACA,YAAA;AA1FJ;;AA8FA;EACE,YAAA;EACA,gBAAA;AA3FF;;AA8FA;EACE,YAAA;EACA,aAAA;AA3FF;;AA8FA;EACE,YAAA;EACA,gBAAA;AA3FF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@mixin descriptionText {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.whatsNewItemWrapper {\n  width: 100%;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n\n  &:not(:last-child) {\n    margin-bottom: 15px;\n  }\n}\n\n.whatsNewItemBody {\n  padding: 25px;\n}\n\n.whatsNewItemTitle {\n  margin: unset;\n  color: var(--tables-primary-row-text-main);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  text-transform: uppercase;\n\n  * {\n    margin: unset;\n  }\n}\n\n.notViewed {\n  padding-left: 18px;\n  position: relative;\n\n  &::before {\n    content: '';\n    width: 8px;\n    height: 8px;\n    background-color: var(--buttons-surface);\n    border-radius: 50%;\n    position: absolute;\n    top: 5px;\n    left: 0;\n  }\n}\n\n.whatsNewItemDescription {\n  width: 100%;\n  margin-top: 15px;\n  margin-bottom: 0;\n  @include descriptionText;\n\n  img {\n    max-width: 600px;\n  }\n\n  ol,\n  li {\n    &::marker {\n      color: var(--tables-secondary-row-sub-title-text);\n    }\n  }\n\n  li {\n    margin: unset;\n  }\n\n  * {\n    margin-top: 15px;\n    margin-bottom: 0;\n    @include descriptionText;\n  }\n\n  .skeletonText {\n    height: 100px;\n  }\n}\n\n.whatsNewItemFooter {\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  border-top: 1px solid var(--tables-primary-row-stroke);\n  justify-content: space-between;\n\n  .skeletonText {\n    height: 40px;\n  }\n}\n\n.whatsNewItemDate {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.whatsNewItemDateIcon {\n  path {\n    stroke: var(--tables-secondary-row-sub-title-text);\n  }\n}\n\n.whatsNewItemMarkFavorite {\n  margin-left: 25px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.whatsNewItemMarkFavoriteIcon {\n  cursor: pointer;\n\n  path {\n    stroke: var(--buttons-surface);\n\n    &:hover {\n      stroke: var(--buttons-hover);\n    }\n  }\n}\n\n.skeletonWrapper {\n  .whatsNewItemTitle {\n    height: 16px;\n  }\n\n  .whatsNewItemDescription {\n    margin-top: 25px;\n    height: 40px;\n  }\n}\n\n.skeletonTextTitle {\n  height: 16px;\n  max-width: 400px;\n}\n\n.skeletonTextDescription {\n  height: 40px;\n  margin-top: 0;\n}\n\n.skeletonTextFooter {\n  height: 18px;\n  max-width: 145px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whatsNewItemWrapper": `whatsNewItemWrapper__dnDbt`,
	"whatsNewItemBody": `whatsNewItemBody__1Ok8M`,
	"whatsNewItemTitle": `whatsNewItemTitle__ldwny`,
	"notViewed": `notViewed__HVAiT`,
	"whatsNewItemDescription": `whatsNewItemDescription__NdPH1`,
	"skeletonText": `skeletonText__BrDTb`,
	"whatsNewItemFooter": `whatsNewItemFooter__jKtgZ`,
	"whatsNewItemDate": `whatsNewItemDate__jvWzB`,
	"whatsNewItemDateIcon": `whatsNewItemDateIcon__AOOVB`,
	"whatsNewItemMarkFavorite": `whatsNewItemMarkFavorite__c2_MG`,
	"whatsNewItemMarkFavoriteIcon": `whatsNewItemMarkFavoriteIcon__Mi571`,
	"skeletonWrapper": `skeletonWrapper__AplYc`,
	"skeletonTextTitle": `skeletonTextTitle__HtKjQ`,
	"skeletonTextDescription": `skeletonTextDescription__iRHeJ`,
	"skeletonTextFooter": `skeletonTextFooter__PkE5I`
};
module.exports = ___CSS_LOADER_EXPORT___;
